import {RouterModule, Routes} from '@angular/router';
import {LandingComponent} from '@rsp/landing/landing.component';
import {CommunityComponent} from '@rsp/community/community.component';
import {AuthGuard} from '@rsp/shared/guards/auth.guard';
import {RoleGuard} from '@rsp/shared/guards/role.guard';
import {AccessRoles} from '@rsp/models/enum/access-roles.enum';
import {StrombilanzComponent} from '@rsp/strombilanz/strombilanz.component';
import {ImpressumComponent} from '@rsp/impressum/impressum.component';
import {CustomPreloadingStrategy} from '@rsp/shared/preload/custom-preloading.strategy';


export const APP_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full'
  },
  {
    path: '',
    component: LandingComponent
  },
  {
    path: 'community',
    component: CommunityComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      expectedRole: AccessRoles.USER_ROLE_VIEW_COMMUNITY_DATA
    }
  },
  {
    path: 'meine-strombilanz', component: StrombilanzComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      expectedRole: AccessRoles.USER_ROLE_VIEW_CUSTOMER_DATA
    }
  },
  {
    path: 'impressum', component: ImpressumComponent,
  },
  {
    path: 'datenschutz', component: ImpressumComponent,
  },
  {
    path: 'kontakt', component: ImpressumComponent,
  },
  {
    path: '**', redirectTo: ''
  }
];

export let AppRouterModule = RouterModule.forRoot(APP_ROUTES, {
  preloadingStrategy: CustomPreloadingStrategy
  // useHash: true,
  // initialNavigation: false
});
